export default __webpack_public_path__ + "static/ipinfo-eda9b0fa9bdce393cc9fdc41f3337e29.svg";